import {
  updateLoginCredentials,
  UpdateLoginCredentialsParams,
} from '@mindfulchefuk/query/LoginCredentials/services'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'

export const useMutationUpdateLoginCredentials = (
  options: UseMutationOptions<void, unknown, UpdateLoginCredentialsParams> = {}
) => useMutation({ mutationFn: updateLoginCredentials, ...options })
